import React, { useState, useRef, useEffect } from "react";
import "./EditTodoList.scss";
import "../../../../components/ModalContent/ModalComponents.scss";
import { normalizeColor } from "../../../../utils/colors";
import ColorPicker from "../../../../components/ColorPicker/ColorPicker";

function EditTodoList({ todoListData, updateTodoList, cancelEditTodoList }) {
  const [title, setTitle] = useState(todoListData?.title || "");
  const [selectedColor, setSelectedColor] = useState(
    normalizeColor(todoListData?.color),
  );
  const [listType, setListType] = useState(todoListData?.type || "todo");
  const [showTitleError, setShowTitleError] = useState(false);

  // Update state when todoListData changes
  useEffect(() => {
    if (todoListData) {
      setTitle(todoListData.title || "");
      setSelectedColor(normalizeColor(todoListData.color));
      setListType(todoListData.type || "todo");
    }
  }, [todoListData]);

  const handleUpdateTodoList = () => {
    if (title.trim()) {
      const colorHex = normalizeColor(selectedColor);
      updateTodoList(todoListData._id, title.trim(), colorHex, listType);
      setShowTitleError(false);
    } else {
      setShowTitleError(true);
    }
  };

  // Set focus on input field when modal opens
  const inputRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        inputRef.current.select(); // Select all text for easy editing
      }
    }, 100); // 100ms delay to ensure DOM is ready
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="edit-todolist-content">
      <div className="modal-title">
        <div>Edit todolist</div>
      </div>
      <div className="modal-form">
        <div className="modal-form-title">Title</div>
        <input
          ref={inputRef}
          type="text"
          className="modal-text-input"
          placeholder="List Title"
          value={title}
          onChange={(e) => {
            setTitle(e.target.value);
            if (showTitleError && e.target.value.trim()) {
              setShowTitleError(false);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleUpdateTodoList();
            }
          }}
        />
        {showTitleError && (
          <div className="modal-helper-text">Please enter a title</div>
        )}

        <div className="modal-form-title">Type</div>
        <div className="modal-checkbox-group">
          <label className="modal-checkbox-label">
            <input
              type="checkbox"
              checked={listType === "todo"}
              onChange={() => setListType("todo")}
            />
            <span>Todo List</span>
          </label>
          <label className="modal-checkbox-label">
            <input
              type="checkbox"
              checked={listType === "checklist"}
              onChange={() => setListType("checklist")}
            />
            <span>Checklist</span>
          </label>
        </div>

        <div className="modal-form-title">Color</div>
        <div className="color-picker-wrapper">
          <ColorPicker
            selectedColor={selectedColor}
            onColorSelect={setSelectedColor}
          />
        </div>
        <div className="modal-form-buttons">
          <button
            className="modal-button cancel"
            onClick={() => {
              cancelEditTodoList();
            }}
          >
            Cancel
          </button>
          <button className="modal-button save" onClick={handleUpdateTodoList}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditTodoList;
